import { render } from "./VisibilityPage.vue?vue&type=template&id=0c0153aa&ts=true"
import script from "./VisibilityPage.vue?vue&type=script&lang=ts"
export * from "./VisibilityPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__